<template>
  <Teleport to="body">
    <div>
      <transition name="overlay">
        <Overlay v-if="open" @click.stop="$emit('update:open', false)" />
      </transition>
      <transition name="popup">
        <div
          v-if="open"
          class="popup-wrapper"
          :class="centered ? 'inset-0' : 'inset-x-0 top-[10vh]'"
        >
          <div class="popup" :class="{ [popupClass]: !!popupClass }">
            <slot name="title">
              <div v-if="title" class="title">{{ title }}</div>
            </slot>
            <slot name="content">
              <div class="content scroll-invisible overscroll-none">{{ text }}</div>
            </slot>
            <slot name="actions">
              <ModalPopupButton v-if="!hideCloseButton" @click="$emit('update:open', false)">{{
                buttonText || $t('common.close')
              }}</ModalPopupButton>
            </slot>
          </div>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import ModalPopupButton from '@/components/common/buttons/ModalPopupButton.vue'
import Overlay from '@/components/common/overlay/Overlay.vue'

withDefaults(
  defineProps<{
    open?: boolean
    popupClass?: string
    title?: string
    text?: string | null
    hideCloseButton?: boolean
    buttonText?: string
    centered?: boolean
  }>(),
  {
    popupClass: '',
    centered: true,
  }
)
</script>

<style scoped lang="postcss">
.popup-wrapper {
  @apply fixed z-[1010] flex flex-col items-center justify-center
  transition-all
  duration-sidebar-opening ease-sidebar-opening;
}
.popup {
  @apply flex flex-col rounded-xl bg-white w-[360px] max-h-[80vh];

  .title {
    @apply text-2xl font-extrabold italic text-accent-500 px-8 pt-8 mb-5;
  }

  .content {
    @apply px-8 pb-8 overflow-auto text-base font-regular text-gray-600 whitespace-pre-wrap;
  }
}

.overlay-leave-to,
.overlay-enter-from {
  @apply opacity-0;
}

.overlay-enter-active {
  @apply duration-sidebar-opening ease-sidebar-opening;
}

.overlay-leave-active {
  @apply duration-sidebar-closing ease-sidebar-closing;
}

.popup-leave-to,
.popup-enter-from {
  @apply top-[100vh];
}

.popup-enter-active {
  @apply duration-sidebar-opening ease-sidebar-opening;
}

.popup-leave-active {
  @apply duration-sidebar-closing ease-sidebar-closing;
}
</style>
